import { BaseFactory } from 'src/services/entity-factory/FactoryInterface';
import ContractCorrections from 'src/value-objects/ContractCorrections';

export interface ApiContractCorrectionsResponse {
  id: number;
  correctedContract: string;
  message: string;
  formalizationId: number;
}

interface ApiContractCorrectionsCreateRequest {
}

export class ContractCorrectionsFactory extends BaseFactory<ContractCorrections> {
  public toEntity(args: ApiContractCorrectionsResponse): ContractCorrections {
    return new ContractCorrections({
      id: args.id,
      typeError: args.correctedContract,
      errorDescription: args.message,
      formalizationId: args.formalizationId,
    });
  }

  public toRequest(contractCorrections: ContractCorrections): ApiContractCorrectionsCreateRequest {
    return {
      id: contractCorrections.id,
      correctedContract: contractCorrections.typeError,
      message: contractCorrections.errorDescription,
      formalizationId: contractCorrections.formalizationId
    };
  }
}


// WEBPACK FOOTER //
// ./src/services/entity-factory/factories/ContractCorrectionsFactory.tsx